import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseRepository } from "./base/base.repository";
import { Utilities } from "../utils/utilities";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class TranslationRepository extends BaseRepository {

  constructor(public httpClient: HttpClient) {
    super(httpClient);
    this.path = 'dashboard/admin/translations';
    this.serviceUrl = Utilities.getTranslateSaveUrl();
  }

  getAllByEnvironment(environment: string) {
    const path = 'download/translations/' + environment;
    return super.get(path);
  }

  getAllByFilterer(environment: string) {
    const path = 'download/translations/' + environment;
    return super.get(path);
  }

  importCsvByEnvironment(environment: string, file: File): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);

    const path: string = 'download/translations/' + environment + '/import';
    return super.postFile(path, formData);
  }

}
